module.exports = __webpack_public_path__ + "img/memoirerings-mobile@2x.390b6e3.jpg";